import React from 'react';
import styled from 'styled-components';
import { ArrowDownOutlined as ArrowDown, ArrowUpOutlined as ArrowUp } from '@ant-design/icons';
import { animated } from 'react-spring';

export const TableContainer = styled(animated.div)``;

export const TableHeadHead = styled.h2`
  color: ${props => props.theme.textLight};
`;

export const ArrowDownOutlined = styled(({ customPatient, ...args }) => <ArrowDown {...args} />)<{
  customPatient: any;
}>`
  margin-right: ${({ customPatient }) => (customPatient ? '' : '11px')};
`;

export const ArrowUpOutlined = styled(({ customPatient, ...args }) => <ArrowUp {...args} />)<{
  customPatient: any;
}>`
  margin-right: ${({ customPatient }) => (customPatient ? '' : '11px')};
`;

export const OverriddenThreshold = styled.span<{ renamedPatMin?: any; renamedPatMax?: any }>`
  text-decoration: ${({ renamedPatMin, renamedPatMax }) =>
    renamedPatMin ? 'line-through' : renamedPatMax ? 'line-through' : ''};
  color: ${({ renamedPatMin, renamedPatMax }) =>
    renamedPatMin ? 'rgba(0, 0, 0, 0.35)' : renamedPatMax ? 'rgba(0, 0, 0, 0.35)' : ''};
`;

export const ThresholdsInput = styled.input`
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0px 0px 0px 0px;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 30%;
  height: 32px;
  padding: 4px 11px;
  color: black;
  font-size: 14px;
  line-height: 1.5;
  background-image: none;
  border: 1px #d9d9d9;
  border-radius: 4px 4px 0px 0px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-bottom: 1px #094074 solid;
  text-align: start;

  @media (max-width: 1370px) {
    width: 70%;
  }

  @media (max-width: 800px) {
    width: 100%;
  }

  &:disabled {
    background: white;
    border-radius: 4px;
    border-bottom: 0px;
  }
`;
